import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function LocationViewer({ title, location_name, location_lat, location_lng }) {

	const { t } = useTranslation();

	return (
		<div className="bg-white border border-[#E6E2D6] rounded-sm p-6" data-testid="horse-map">
			<h2 className="text-xl font-semibold text-[#1A3C34] mb-4 font-['Playfair_Display']">
				{t('horse.location')}
			</h2>
			<div className="h-[300px] rounded-sm overflow-hidden border border-[#E6E2D6]">
				<MapContainer
					center={[location_lat, location_lng]}
					zoom={10}
					style={{ height: '100%', width: '100%' }}
				>
					<TileLayer
						attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
					<Marker position={[location_lat, location_lng]}>
						<Popup>
							<strong>{title}</strong>
							{location_name && <br />}
							{location_name}
						</Popup>
					</Marker>
				</MapContainer>
			</div>
			{location_name && (
				<p className="text-sm text-[#666055] mt-2 flex items-center gap-1">
					<MapPin className="w-4 h-4" /> {location_name}
				</p>
			)}
		</div>

	);
};